export default "__VITE_ASSET__hDawWXNb__"